<app-crudbar-nav [title]="title" (onReady)="doComReady($event,'crudbar-nav')">
</app-crudbar-nav>

<mat-tab-group #masterTabGroup mat-stretch-tabs="false" mat-align-tabs="start" class="h-full"
  style="vertical-align: top;" animationDuration="0ms" dynamicHeight (selectedTabChange)="onMasterTabChange($event)">
  <mat-tab #myTabGrid label="瀏覽">
    <div class="border-2 border-red-300">
      <app-jkaggrid #myGrid [height]="400" [columnDefs]="srv.columnDefs" (afterGridReadyAg)="afterGridReady($event)"
        (rowClicked)="agRowClicked($event)" (rowSelected)="agRowSelected($event)" (onInsert)="doUIInsert($event)"
        (onDelete)="doUIDelete($event)"></app-jkaggrid>

    </div>
  </mat-tab>

  <mat-tab #myTabDetail label="明細">
    <!-- <app-openwin-tabedit [srv]="srv"></app-openwin-tabedit> -->
    <div style="max-height: 400px; overflow-y: auto;">
      <div class="jk-grid-cols-2">
        <app-jktext label="標題" [value]="item.Title">
        </app-jktext>
        <app-jktext label="備註" [value]="item.PS">
        </app-jktext>
        <app-jktext label="主資料表" [value]="item.MainTable">
        </app-jktext>
        <app-jktext label="序號" [value]="item.ITEM">
        </app-jktext>
        <app-jktext label="類別" [value]="item.TYPE">
        </app-jktext>
        <app-jktextarea height="250px" label="顯示" #DisplayCom id="Display" [(value)]="item.Display" [readonly]="true">
        </app-jktextarea>
        <app-jktextarea height="250px" label="欄位排序" #SQLOrderCom id="SQLOrder" [(value)]="item.SQLOrder"
          [readonly]="true">
        </app-jktextarea>
        <app-jktext label="建檔者" [value]="item.CreateUserID">
        </app-jktext>
        <app-jkdatefield label="建立日期" #CreateDateCom id="CreateDate" [(date)]="item.CreateDate" [readonly]="true">
        </app-jkdatefield>
        <app-jkdatefield label="修改日期" #ModiDateCom id="ModiDate" [(date)]="item.ModiDate" [readonly]="true">
        </app-jkdatefield>
        <app-jktextarea height="250px" label="SQLSelect" #SQLSelectCom id="SQLSelect" [(value)]="item.SQLSelect"
          [readonly]="true">
        </app-jktextarea>
        <app-jktextarea height="250px" label="SQLWhere" #SQLWhereCom id="SQLWhere" [(value)]="item.SQLWhere"
          [readonly]="true">
        </app-jktextarea>
        <app-jktextarea height="250px" label="MAP" #MAPCom id="MAP" [(value)]="item.MAP" [readonly]="true">
        </app-jktextarea>
        <app-jktextarea height="250px" label="SQLReturn" #SQLReturnCom id="SQLReturn" [(value)]="item.SQLReturn"
          [readonly]="true">
        </app-jktextarea>

      </div>
    </div>
  </mat-tab>


  <mat-tab #myTabAdvance label="進階">
    <div class="border-2 min-h-50">[空白]</div>
  </mat-tab>
</mat-tab-group>